export default "__VITE_ASSET__DElmF0i1__"